<form [formGroup]="form" class="form">
  @if (items && items.length > 1) {
    <mat-form-field>
      <mat-label>Select your payment method</mat-label>
      <mat-select formControlName="method">
        @for (item of items; track item) {
          <mat-option [value]="item">{{item.bankInfo?.bankName || '---'}} ****{{item.stripeLast4}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field>
    <mat-label>Start date</mat-label>
    <input matInput type="date" formControlName="startDate" min="1970-01-01">
  </mat-form-field>
  <mat-form-field>
    <mat-label>End date</mat-label>
    <input matInput type="date" formControlName="endDate" min="1970-01-01">
  </mat-form-field>
  <button mat-button type="button" (click)="clearDates()" [disabled]="!form.get('startDate').value && !form.get('endDate').value">Clear dates</button>
</form>
<p class="date-hint">Dates are inclusive and shown in {{ displayTimezone }}.</p>
@if (dateError) {
  <p role="alert">{{ dateError }}</p>
}
@if (isLoading) {
  <span class="mandatetext">Loading Charge History…</span>
}
@if (loadError) {
  <div class="mandatetext" role="alert">
    {{loadError}}
    @if (form.get('method').value) {
      <button mat-button type="button" (click)="retryPage()">Retry</button>
    }
  </div>
}
@if (!isLoading && !loadError && hasLoadedPage && invoices.length === 0 && invoicesWithoutPaymentMethod.length === 0 && carriedForwardInvoices.length === 0) {
  <span class="mandatetext">No charges match this payment method and date range.</span>
}
@if (carriedForwardInvoices.length > 0) {
  <span class="title">Amounts carried forward</span>
  <app-stripe-chargehistory-table [invoices]="carriedForwardInvoices"></app-stripe-chargehistory-table>
}
@if (invoicesWithoutPaymentMethod && invoicesWithoutPaymentMethod.length > 0) {
  <span class="title">Invoices without a payment method</span>
}
@if (invoicesWithoutPaymentMethod && invoicesWithoutPaymentMethod.length > 0) {
  <div>
    <app-stripe-chargehistory-table [invoices]="invoicesWithoutPaymentMethod"></app-stripe-chargehistory-table>
  </div>
}
@if (invoices && invoices.length > 0) {
  <span class="title">Invoices with a payment method</span>
}
@if (invoices && invoices.length > 0) {
  <div>
    <app-stripe-chargehistory-table [invoices]="invoices"></app-stripe-chargehistory-table>
  </div>
}

@if (hasLoadedPage || isLoading || (loadError && form.get('method').value)) {
  <nav class="pagination" aria-label="Charge History pages">
    <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="isLoading || !!loadError || pageIndex === 0">Previous</button>
    <span aria-live="polite">Page {{ pageIndex + 1 }}@if (hasLoadedPage && !hasMore) {
      · Last page
    }</span>
    <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="isLoading || !!loadError || !hasMore">Next</button>
    <span>50 records per page</span>
  </nav>
}
